import React from 'react';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { ValidationIcon, ValidationMessage } from '@printdeal/ui-library';

interface Props {
  fieldName: string;
  maxVal: number;
}

const DesignOptionsError = ({
  fieldName,
  maxVal,
}: Props) => {
  const intl = useIntl();
  const {
    formState: { errors },
  } = useFormContext();

  if (!errors[fieldName] || !errors[fieldName]?.type) {
    return null;
  }

  let errorText = intl.formatMessage({
    id: 'account.order.service.fileDesign.error.generic',
    defaultMessage: 'Please select valid options',
  });

  if (errors[fieldName]?.type === 'too_small' && maxVal > 1) {
    errorText = intl.formatMessage({
      id: 'account.order.service.fileDesign.error.atLeastMin',
      defaultMessage: 'Please select at least one option.',
    }) as string;
  } else if (errors[fieldName]?.type === 'too_small') {
    errorText = intl.formatMessage({
      id: 'account.order.service.fileDesign.error.min',
      defaultMessage: 'Please select an option.',
    }) as string;
  }

  if (errors[fieldName]?.type === 'too_big') {
    errorText = intl.formatMessage({
      id: 'account.order.service.fileDesign.error.max',
      defaultMessage: 'Please select {max} at most.',
    }, {
      max: maxVal,
    }) as string;
  }

  return (
    <ValidationMessage variant="error" className="pd-flex pd-flex-row pd-gap-2">
      <ValidationIcon variant="error" />
      {errorText}
    </ValidationMessage>
  );
};

export default DesignOptionsError;
